import React from 'react';
/**
 * Bronson [ListInline](https://bronson.vwfs.io/bluelabel/docs/objects/list-inline.html) component.
 */
export const ListInline = ({ children, testId, ...otherProps }) => {
    return (React.createElement("ul", { ...otherProps, "data-testid": testId, className: "o-list-inline" }, children /* Use 'ListInline.Item' component. */));
};
ListInline.displayName = 'ListInline';
/**
 * Bronson ListInlineItem component (nested).
 */
export function ListInlineItem({ children, ...otherProps }) {
    return React.createElement("li", { ...otherProps }, children);
}
ListInlineItem.displayName = 'ListInline.Item';
ListInline.Item = ListInlineItem;
